module.exports = __webpack_public_path__ + "static/media/university-of-texas-austin.9d1dcfcf.png";